import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatTab } from '@angular/material/tabs';
import { ITableColumns } from 'app/modules/reports/interfaces/reporting-data';
import { ICustomTableInfoExtend } from 'app/modules/shared/components/custom-mat-table/custom-mat-table.component';
import { NoDataActionType } from 'app/modules/shared/interfaces/no-data';
import { CustomMatTableService } from 'app/modules/shared/services/custom-mat-table.service';
import { ReportingService } from 'app/modules/reports/services/reporting.service';

@Component({
    selector: 'app-client-health',
    templateUrl: './client-health.component.html',
    styleUrls: ['./client-health.component.scss'],
})
export class ClientHealthComponent implements OnInit {
    constructor(
        private http: HttpClient,
        private _reportService: ReportingService,
        private _customMatTableService: CustomMatTableService
    ) {}

    tab: string;
    tabs: string[];
    results: any[];
    resultsOriginal: any[];
    searchTerms: string = '';
    columnInfoList: ITableColumns[];
    customTableInfo: ICustomTableInfoExtend;
    action: NoDataActionType;
    timeOutHolder: any;

    ngOnInit() {
        this.initiateTableProperties();
        this.getData();
    }

    initiateTableProperties() {
        this.columnInfoList = [
            {
                fieldId: 'clientFullName',
                fieldName: 'Client Name',
                fieldOrder: 0,
                isSortable: true,
                defaultSorting: 'asc',
                headerAlignment: 'left',
                dataAlignment: 'left',
                dataType: 'string',
                width: 250,
            },
            {
                fieldId: 'dataLoadType',
                fieldName: 'Data Load Type',
                fieldOrder: 2,
                isSortable: false,
                headerAlignment: 'left',
                dataAlignment: 'left',
                dataType: 'string',
                decimalPlaces: 0,
                width: 90,
                hideIf: 'ui',
            },
            {
                fieldId: 'numOfInserts',
                fieldName: '# of Inserts',
                fieldOrder: 3,
                isSortable: true,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'number',
                decimalPlaces: 0,
                width: 70,
            },
            {
                fieldId: 'numOfUpdates',
                fieldName: '# of Updates',
                fieldOrder: 4,
                isSortable: true,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'number',
                decimalPlaces: 0,
                width: 70,
            },
            {
                fieldId: 'lastLOSUpdate',
                fieldName: 'Last Update',
                fieldOrder: 5,
                isSortable: true,
                headerAlignment: 'right',
                dataAlignment: 'right',
                dataType: 'date',
                decimalPlaces: 0,
                width: 110,
            },
        ];

        this.customTableInfo = {
            tableId: 'settings-client-health-table',
            tableHeight: 600,
            hasData: false,
            isDataReady: false,
            columnInfoList: this.columnInfoList,
            dataSet: [],
            searchTerm: this.searchTerms,
            action: NoDataActionType.pageStart,
            title: 'Client Health',
            bandColorList: [],
            dataHandleInUiSide: true,
            showSummary: false,
        };
    }

    getData() {
        this.customTableInfo.dataSet = [];
        this.customTableInfo = this._customMatTableService.refreshCustomMatTable(
            this.customTableInfo,
            false,
            false,
            this.action,
            this.searchTerms
        );

        this.http.get<any>(`https://${window.location.host}/api/v0.5/ClientHealth`).subscribe({
            next: (res) => {
                if (res && res.length > 0) {
                    this.resultsOriginal = res;
                    this.results = this.resultsOriginal;
                    let uniqueTypes = res
                        .map((item) => item.dataLoadType)
                        .filter((value, index, self) => self.indexOf(value) === index);

                    if (uniqueTypes?.length != 0) {
                        this.tabs = uniqueTypes;
                        this.tab = uniqueTypes[0];
                    } else {
                        this.tabs = null;
                    }
                    this.reloadGrid();
                } else {
                    this.customTableInfo.dataSet = [];
                    this.customTableInfo = this._customMatTableService.refreshCustomMatTable(
                        this.customTableInfo,
                        false,
                        true,
                        this.action,
                        this.searchTerms
                    );
                }
            },
            error: (error) => {
                this.customTableInfo.dataSet = [];
                this.customTableInfo = this._customMatTableService.refreshCustomMatTable(
                    this.customTableInfo,
                    false,
                    true,
                    NoDataActionType.error,
                    this.searchTerms
                );

                throw new Error(error);
            },
        });
    }

    reloadGrid() {
        let data = this.results.filter((item) => item.dataLoadType === this.tab);

        this.customTableInfo.dataSet = data;
        this.customTableInfo = this._customMatTableService.refreshCustomMatTable(
            this.customTableInfo,
            data?.length > 0,
            true,
            this.action,
            this.searchTerms
        );
    }

    handleTabChange(event): void {
        let selectedTab: MatTab = event.tab;
        if (selectedTab.textLabel !== this.tab) {
            this.tab = event.tab.textLabel;
            this.reloadGrid();
        }
    }

    exportToExcel() {
        this._reportService.setExportColumnsAndExportToExcel(
            this.columnInfoList,
            this.results,
            'client-health-'
        );
    }

    clientSearch() {
        if (this.timeOutHolder) {
            clearTimeout(this.timeOutHolder);
        }

        this.timeOutHolder = setTimeout(() => {
            this.results = this.resultsOriginal.filter((x) =>
                x.clientFullName.toLowerCase().includes(this.searchTerms.toLowerCase())
            );
            this.reloadGrid();
        }, 800);
    }
}
